<template>
    <div class="profile-root">
        <Header :label="fullName" overlap="small" />

        <MainLayout margin-top>
            <FavoriteModule slot="center" />
            <PostingModule
                slot="center"
                noToggles
                :label="$t('mypage.suggestedPositions')"
                :data="data()"
                :queryInfo="queryInfo()"
                :isLoading="loading()"
            />

            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />
            <WidgetModule slot="right" />
        </MainLayout>
    </div>
</template>

<script>
// Services
import AnalyticService from '~/services/AnalyticService';

// Project components
import Header from '../../components/layouts/Header';
import MainLayout from '../../components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import FeaturedResource from '~/components/smart/FeaturedResource';
import WidgetModule from '~/components/smart/WidgetModule';

// Page components
import PostingModule from '~/shared/postingmodule/PostingModule';
import FavoriteModule from './components/FavoriteModule';

// Utils
import userDataToName from '~/utils/user/userDataToName';

export default {
    name: 'MyPageOld',
    components: {
        Header,
        MainLayout,
        PostingModule,
        ProfileModule,
        VerifyModule,
        FavoriteModule,
        FeaturedResource,
        WidgetModule,
    },
    data: () => ({
        forceUpdate: false,
        followedCompanies: [],
        isLoadingFollowedCompanies: false,
    }),
    computed: {
        fullName() {
            return userDataToName(this.user.data, 'mypage.header');
        },
        postings() {
            return this.$interfaces.posting.get({ reactive: true });
        },
        isAuthenticated() {
            return this.$interfaces.logInModule.isLoggedIn();
        },
        user() {
            return this.$interfaces.user.me.get({ reactive: true });
        },
    },
    methods: {
        data() {
            return (this.postings.data || []).slice(0, 4);
        },
        queryInfo() {
            return this.postings.queryInfo;
        },
        loading() {
            return this.postings.loading;
        },
        error() {
            return this.postings.error;
        },
    },
    mounted() {
        AnalyticService.impressionEvent(AnalyticService.IMPRESSION_ACTIONS.MYPAGE_VIEW_ACTION);
    },
};
</script>

<style scoped>
.profile-root {
    padding-bottom: 100px;
}
</style>
